import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    // 图片组件不展示提示
    isImage: function isImage(vm) {
      return !vm.form.valueKey.includes('image');
    }
  }
};